import React from 'react'
import { generatePath } from 'react-router'
import styled from 'styled-components'

import { useListRequest, useRequest } from '../hooks/request'
import { PATHS } from '../constants/paths'
import { gridList, gridDelete } from '../requests/grid'
import { dateToDateTime } from '../utils/dateToDDMMYYYY'
import { DOCUMENT_STATUS } from '../constants/documentStatus'
import { useGenericStorage } from '../data/GenericStorageContext'
import { createDuplicateName } from '../utils/createDuplicateName'
import { history } from '../utils/history'
import { VARIANT_SECONDARY } from '../constants/variants'

import { PageTitle } from './common/PageTitle'
import { PageContent } from './layout/layout'
import { HiddenListButtonWrapper, List, ListButtonWrapper } from './common/List'
import { Margin } from './common/Margin'
import {
  DummyButton, EditButton, GoToItemCreate, GreenButton, ViewButton,
} from './common/Button'
import { DraftIcon } from './common/DraftIcon'
import { DeleteButton } from './common/ConfirmButton'
import { Duplicate } from './icons/Duplicate'
import { SearchCreateWrapper } from './common/SearchCreateWrapper'
import { ListSearch } from './common/ListSearch'
import { H3 } from './common/Typography'

const titles = [
  { title: 'name' },
  { title: 'creationDate' },
  {
    size: 0,
    content: (
      <HiddenListButtonWrapper>
        <DummyButton />
        <Margin h={10} />
        <DummyButton />
        <Margin h={10} />
        <DummyButton />
      </HiddenListButtonWrapper>
    )
    ,
  },
]

const displayItem = (item, props) => [
  {
    content: (
      <Row>
        {item.name}
        <Margin h={15} />
        {item.status === DOCUMENT_STATUS.DRAFT && (
          <DraftIcon />
        )}
      </Row>
    ),
  },
  dateToDateTime(item.creationDate),
  {
    content: (
      <ListButtonWrapper>
        <GreenButton
          icon={<Duplicate />}
          onClick={() => {
            // for some reason react-router state didnt work, so had to do that
            const duplicatedItem = { ...item }
            delete duplicatedItem.id
            props.setGridToDuplicate(duplicatedItem)
            history.push(PATHS.GRID_CREATE)
          }}
        />
        <Margin h={10} />
        {item.status === DOCUMENT_STATUS.DRAFT ? (
          <EditButton
            to={generatePath(PATHS.GRID_EDIT, { id: item.id })}
          />
        ) : (
          <ViewButton
            to={generatePath(PATHS.GRID_EDIT, { id: item.id })}
          />
        )}
        <Margin h={10} />
        <DeleteButton
          loading={props.deletingId === item.id}
          titleTrad="confirmDeleteGrid"
          onConfirm={() => props.onConfirmDelete({ id: item.id })}
          disabled={item.internships.length}
        />
      </ListButtonWrapper>
    ),
  },
]

export const GridList = () => {
  const { mergeIntoGenericStorage } = useGenericStorage()
  const setGridToDuplicate = (i) => mergeIntoGenericStorage({
    gridToDuplicate: createDuplicateName({ item: i }),
  })
  const gridListRequest = useListRequest({
    start: true,
    request: gridList,
  })

  const gridDeleteRequest = useRequest({
    request: gridDelete,
    handler: (p) => p.then(gridListRequest.fetch),
  })

  return (
    <>
      <PageTitle tradId="gridList" />
      <PageContent>
        <SearchCreateWrapper>
          <GoToItemCreate
            tradId="gridCreate"
            to={PATHS.GRID_CREATE}
          />
          <Margin v={10} />
          <div>
            <H3 tradId="searchTitle" bold variant={VARIANT_SECONDARY} />
            <Margin v={15} />
            <ListSearch onSearch={gridListRequest.setSearch} placeholder="name" />
          </div>
        </SearchCreateWrapper>
        <List
          setGridToDuplicate={setGridToDuplicate}
          onConfirmDelete={gridDeleteRequest.fetch}
          listRequest={gridListRequest}
          columnTitles={titles}
          deletingId={gridDeleteRequest.state.params?.id}
          displayItem={displayItem}
        />
      </PageContent>
    </>
  )
}

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`
